import { Franchise } from '@/types';
import { Typography } from 'antd';

interface Props {
  franchisor: Partial<Franchise>;
}

export default function FranchisorTrainingAdminSection({ franchisor }: Props) {
  return (
    <div className="details-section-column">
      <div className={'details-section-line'}>
        <Typography.Text className="general-info-text">
          Financial Assistance
        </Typography.Text>
        <Typography.Text className="general-info-value">
          {franchisor?.financialAssistance !== undefined
            ? franchisor.financialAssistance
              ? 'Yes'
              : 'No'
            : 'N/A'}
        </Typography.Text>
      </div>
      <div className={'details-section-column'}>
        <Typography.Text className="general-info-text">
          Financial Assistance Details
        </Typography.Text>
        <Typography.Text className="general-info-value">
          {franchisor?.financialAssistanceDetails
            ? franchisor.financialAssistanceDetails
            : '-'}
        </Typography.Text>
      </div>
      <div className={'details-section-line'}>
        <Typography.Text className="general-info-text">
          Site Selection Assistance
        </Typography.Text>
        <Typography.Text className="general-info-value">
          {franchisor?.siteSelectionAssistance !== undefined
            ? franchisor.siteSelectionAssistance
              ? 'Yes'
              : 'No'
            : 'N/A'}
        </Typography.Text>
      </div>
      <div className={'details-section-line'}>
        <Typography.Text className="general-info-text">
          Recruiting Assistance
        </Typography.Text>
        <Typography.Text className="general-info-value">
          {franchisor?.recruitmentAssistance !== undefined
            ? franchisor.recruitmentAssistance
              ? 'Yes'
              : 'No'
            : 'N/A'}
        </Typography.Text>
      </div>
      <div className={'details-section-line'}>
        <Typography.Text className="general-info-text">
          Lease Negotiation Assistance
        </Typography.Text>
        <Typography.Text className="general-info-value">
          {franchisor?.leaseNegotiationAssistance !== undefined
            ? franchisor.leaseNegotiationAssistance
              ? 'Yes'
              : 'No'
            : 'N/A'}
        </Typography.Text>
      </div>
      <div className={'details-section-line'}>
        <Typography.Text className="general-info-text">
          Co-op Advertising
        </Typography.Text>
        <Typography.Text className="general-info-value">
          {franchisor?.coopAdvertising !== undefined
            ? franchisor.coopAdvertising
              ? 'Yes'
              : 'No'
            : 'N/A'}
        </Typography.Text>
      </div>
      <div className={'details-section-column'}>
        <Typography.Text className="general-info-text">
          Training
        </Typography.Text>
        <Typography.Text className="general-info-value">
          {franchisor?.training ? franchisor.training : '-'}
        </Typography.Text>
      </div>
      <div className={'details-section-column'}>
        <Typography.Text className="general-info-text">
          A Day In The Life Of The Owner
        </Typography.Text>
        <Typography.Text className="general-info-value">
          {franchisor?.dayInTheLifeOfTheOwner
            ? franchisor.dayInTheLifeOfTheOwner
            : '-'}
        </Typography.Text>
      </div>

      <div className={'details-section-column'}>
        <Typography.Text className="general-info-text">
          Who Is An Ideal Candidate
        </Typography.Text>
        <Typography.Text className="general-info-value">
          {franchisor?.whoIsAnIdealCandidate
            ? franchisor.whoIsAnIdealCandidate
            : '-'}
        </Typography.Text>
      </div>
    </div>
  );
}
